import React from 'react'
import { CartInterpreter } from '../machines/cartMachine'

export const CartContext = React.createContext({
  cartService: {} as CartInterpreter,
})
